/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_H_TheyInputs */

const en_cp_cmp_h_they = /** @type {(inputs: Cp_Cmp_H_TheyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Their focus`)
};

const id_cp_cmp_h_they = /** @type {(inputs: Cp_Cmp_H_TheyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokus mereka`)
};

/**
* | output |
* | --- |
* | "Their focus" |
*
* @param {Cp_Cmp_H_TheyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_h_they = /** @type {((inputs?: Cp_Cmp_H_TheyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_H_TheyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_h_they(inputs)
	return en_cp_cmp_h_they(inputs)
});